import {
  HORIZONTAL_ASPECTS_STRING,
  SQUARE_ASPECTS_STRING,
  VERTICAL_ASPECT_STRING
} from '@anm/data/aspects';

import { TemplatePage } from './types';

const socialMediaPage: TemplatePage = {
  header: {
    color: '#DEDFE4',
    icon: 'images/video-templates/social_media.jpg',
    title: 'Free Video Templates For Any Social Media',
    title_meta: '500+ Customizable Social Media Video Templates',
    description_meta:
      'Enjoy the process of video making and editing with Wave.video’s collections of customizable social media video templates.',
    description:
      'Enjoy the process of video making and editing with Wave.video’s collections of customizable social media video ' +
      'templates. Easy-to-edit and free!'
  },
  footer: {
    category: 'Social Media',
    description:
      'With Wave.video’s collections of social media video templates, you won’t need to hire a high-end graphic designer ' +
      'to make engaging video content. Just pick a template that suits your needs best, customize it to your branding, and ' +
      'download or share directly on social media. Easy as one-two-three!'
  },
  content: [
    {
      type: 'slider',
      title: 'YouTube Shorts Video Templates',
      name: 'social-media-youtube-shorts',
      search: {aspects: VERTICAL_ASPECT_STRING }
    },
    {
      type: 'slider',
      title: 'Facebook Video Templates',
      name: 'social-media-facebook',
      search: {
        price_min: '0',
        name: 'facebook',
        tags: 'facebook',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Instagram Video Templates',
      name: 'social-media-instagram',
      search: {
        aspects: VERTICAL_ASPECT_STRING
      }
    },
    {
      type: 'slider',
      title: 'LinkedIn Video Templates',
      name: 'social-media-linkedin',
      search: {
        name: 'linkedin',
        tags: 'linkedin',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'TikTok Video Templates',
      name: 'social-media-tiktok',
      search: {
        name: 'tiktok',
        tags: 'tiktok',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Pinterest Video Templates',
      name: 'social-media-pinterest',
      search: {
        name: 'pinterest',
        tags: 'pinterest',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Twitter Video Templates',
      name: 'social-media-twitter',
      search: {
        name: 'twitter',
        tags: 'twitter',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'YouTube Video Templates',
      name: 'social-media-youtube',
      search: {
        aspects: HORIZONTAL_ASPECTS_STRING,
        price_min: '0'
      }
    },
    {
      type: 'stocks',
      title: 'social media',
      search: { name: 'social media' }
    },
    { type: 'calendar' }
  ]
};

export default socialMediaPage;
